import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { H1 } from '@jetbrains/ring-ui/components/heading/heading';
import { Breadcrumbs } from './breadcrumbs';
import styles from './page-title.css';
export function PageTitle({ title, className, breadcrumbs, rightPanel, children }) {
    const pageTitle = title || 'New page';
    return (_jsxs("div", { className: styles.pageTitleContainer, children: [_jsx(Breadcrumbs, { breadcrumbs: breadcrumbs !== null && breadcrumbs !== void 0 ? breadcrumbs : [] }), _jsxs("div", { className: classNames(styles.pageTitle, className), "data-test": "page-title", children: [_jsx(H1, { className: styles.title, children: pageTitle }), children, rightPanel && (_jsx("div", { className: styles.pageTitleRightPanel, "data-test": "page-title-right-panel", children: rightPanel }))] })] }));
}
